import { provideComponent } from 'scrivito'

import { Page } from './PageObjClass'
import { EntityListContextProvider } from '../../Components/EntityListContext'

provideComponent(Page, ({ page }) => (
  <EntityListContextProvider
    id="main"
    key={page.id()}
    content={page}
    attribute="body"
  />
))
